// extracted by mini-css-extract-plugin
module.exports = {"introduction":"introduction_introduction__Hty8G","introductionContainer":"introduction_introductionContainer__TkL3W","freeText":"introduction_freeText__iKw6M"};